<script>
import mixin from './../mixin';

import SourceSet from './SourceSet.vue';

export default {
    mixins: [mixin],
    components: { SourceSet },
    props: {
        item: Object,
    },
};
</script>

<template>
    <a :href="item.url" class="card is-flex is-clipped">
        <div v-if="item.imageSets && item.imageSets.length" class="card-image is-clipped is-rectangle">
            <source-set :imageSets="item.imageSets" />
        </div>

        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column content">
            <div v-show="item.date" class="block">
                <p class="has-text-weight-bold">{{ toDateStr(item.date) }}</p>
            </div>
            <h3 v-show="item.name" class="card-title title is-5 has-text-weight-bold">{{ item.name }}</h3>
            <p v-show="item.intro" class="block mt-auto" v-html="item.intro"></p>
        </div>
    </a>
</template>
